import { TBody } from '../../../components/common/table/TBody/TBody';
import { Table } from '../../../components/common/table/Table/Table';
import { ListHeader } from './listHeader/ListHeader';
import { ListRow } from './listRow/ListRow';
import './List.scss';
import { ListRowDoseEngine } from './listRow/ListRowDoseEngine';
import { ListHeaderDoseEngine } from './listHeader/ListHeaderDoseEngine';

export interface ListProps {
  token: string | null;
  listedFiles: any[];
  tableName: string | null;
  showUploadPopup: (show: boolean) => void;
}

export function List({ token, listedFiles, showUploadPopup }: ListProps) {
  return (
    <>
      <Table style={{ width: '50%' }}>
        <div className="divider">
          <ListHeader />
          <TBody className="list-table-body">
            {Object.entries(listedFiles).map(([key, listItem]: [string, any], index: number) => (
              <ListRow val={listItem} index={index} token={token} key={listItem['Key']} showUploadPopup={(show) => showUploadPopup(show)} />
            ))}
          </TBody>
        </div>
      </Table>

      <Table style={{ width: '50%' }}>
        <div className="divider1">
          <ListHeaderDoseEngine />
          <TBody className="list-table-body">
            {Object.entries(listedFiles).map(([key, listItem]: [string, any], index: number) => (
              <ListRowDoseEngine val={listItem} index={index} token={token} key={listItem['Key']} showUploadPopup={(show) => showUploadPopup(show)} />
            ))}
          </TBody>
        </div>
      </Table>
    </>
  );
}
